(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmOpportunityStatusSearch', CrmOpportunityStatusSearch);

    CrmOpportunityStatusSearch.$inject = ['$resource'];

    function CrmOpportunityStatusSearch($resource) {
        var resourceUrl =  'api/_search/crm-opportunity-status/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
